/*****************************************************************
   JAVASCRIPT
   - Imports
   - Foundation
   - Sticky Nav
   - Mobile Navigation
   - Smooth scroll
   - Chosen (custom select dropdown)
   - Team filter
   - Projects loader
   - Slick JS
   - Touch devices
   - Tabs prev/next
*****************************************************************/



// Imports
// ------------------------------------------------------------
import $ from 'jquery';
// this is needed if you want to use jquery inline in template
window.$ = window.jQuery = require('jquery');
// $(document).ready(function () {}); // <-- for reference

import '../bower_components/foundation-sites/dist/foundation.js';
import 'chosen-js';
import 'slick-carousel';



// Foundation
// ------------------------------------------------------------
$(document).foundation();
// $("#exampleModal1").foundation('reveal', 'open');
// $('#exampleModal1').foundation('open');



// Sticky Nav
// ------------------------------------------------------------
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll > 0) {
        $("nav").addClass("stick");
    } else {
        $("nav").removeClass("stick");
    }
});



// Mobile Navigation
// ------------------------------------------------------------
// subnav
$('.subnav').removeClass('open');

$('.subnav-trigger').click(function(e2) {
  e2.preventDefault();

  $(this).siblings('.subnav').toggleClass('open');
});



// Smooth scroll
// ------------------------------------------------------------
$("a[href='#contact']").click(function(){
    $('html, body').animate({
        scrollTop: $( $.attr(this, 'href') ).offset().top
    }, 500);
    return false;
});



// Chosen (custom select dropdown)
// ------------------------------------------------------------
if ( $('.custom-select').length ) {
  // give it the Chosen treatment
  $('.custom-select').chosen({
    disable_search: true,
    inherit_select_classes: true,
    // width: '275px'
  });

  // go to the linked page
  // redirect to url
  $('.goto').change(function() {
    // set the window's location property to the value of the option the user has selected
    window.location = $(this).val();
  });
}



// Team filter
// ------------------------------------------------------------
// Adapted from 
// http://blog.grapii.com/2010/08/how-to-build-a-simple-search-filter-with-jquery/

jQuery.expr[':'].Contains = function(a,i,m){
    return (a.textContent || a.innerText || "").toUpperCase().indexOf(m[3].toUpperCase())>=0;
};

function  listFilter(header, list) {
  // set form input as variable
  var input = $('.team-filter');

  // filter functionality
  $(input).change(function() {
    // get the input value
    var filter = $(this).val();

    if(filter) {
      $(list).find('.js-filter:not(:Contains(' + filter + '))').closest('.column').slideUp();
      $(list).find('.js-filter:Contains(' + filter + ')').closest('.column').slideDown();
    } else {
      $(list).find('.column').slideDown();
    }
    return false;
  })
  .keyup(function() {
    $(this).change();
  });
}

$(function() {
  listFilter($('.row'), $('.team'));
});


// Projects loader
// ------------------------------------------------------------
// $(function () {
//   $('.more-projects').hide();

//   if ( $('.view-more-projects').length ) {
//     var page = 2;
    
//     var segments = $('.view-more-projects').data('lasturl').split( '/' );
//     // console.log("SEGMENTS: " + segments);
    
//     var catSeg = segments[5];
//     // console.log("CATEGORY SEGMENT: " + catSeg);
    
//     var newSeg = $('.view-more-projects').data('lasturl');
//     // console.log('NEW SEGMENT: ' + newSeg);
    
//     var lastSeg = newSeg.substring(newSeg.lastIndexOf('/') + 1);
//     // console.log("LAST SEGMENT: " + lastSeg);

//     var lastPageNumber = lastSeg.replace('p', '');
//     // var lastPageNumber = $('.view-more-projects').data('totalpages');
//     // console.log("LAST PAGE NUMBER: " + lastPageNumber);

//     var totalPages = $('.view-more-projects').data('totalpages');
//     // console.log("TOTAL PAGES: " + totalPages);

    
//     // FOR MAIN PROJECTS PAGE
//     $('.view-more-projects.main').click (function (e) {  
//       e.preventDefault();

//       var pgUri = '/projects/p';

//       // change page number
//       var newpage = pgUri + page;
//       // console.log('NEW PAGE: ' + newpage)
//       page++;

//       // add the projects
//       $('.more-projects').fadeIn().append($('<div class="row small-up-1 medium-up-3"></div>').load(newpage + ' .column.project').fadeIn(2000));

//       // console.log('PAGE: ' + page + ' / LAST PAGE: ' + lastPageNumber);

//       if ( page === lastPageNumber ) {
//         $('.view-more-projects').fadeOut();
//       }
//     });

//     // FOR PROJECTS BY CATEGORY PAGE
//     $('.view-more-projects.by-cat').click (function (e) {  
//       e.preventDefault();

//       var pgUri = '/projects/market/' + catSeg + '/p';
//       // console.log("PAGE URI: " + pgUri);

//       // change page number
//       var newpage = pgUri + page;
//       page++;
//       // console.log('NEW PAGE: ' + newpage);
//       // console.log('PAGE #: ' + page);

//       // add the projects
//       $('.more-projects').fadeIn().append($('<div class="row small-up-1 medium-up-3"></div>').load(newpage + ' .column.project').fadeIn(2000));

//       var stopPage = page - 1;
//       // console.log("STOP @ PAGE: " + stopPage);

//       // if ( page === lastPageNumber ) {
//       if ( stopPage === totalPages ) {
//         $('.view-more-projects').fadeOut();
//       }
//     });
//   }
  
// });



// Slick JS
// ------------------------------------------------------------
// Project image slider on project detail page
$('#project-viewer').on('open.zf.reveal', function() {
  $('.project-viewer-images').slick('setPosition', 0);
});

$('.project-viewer-images').slick({
  fade: true,
  // infinite: false
  nextArrow: '<span class="slick-next"><img src="/assets/img/icon-carousel-right-green.png" srcset="/assets/img/icon-carousel-right-green.png 1x, /assets/img/icon-carousel-right-green@2x.png 2x" alt=""></span>',
  prevArrow: '<span class="slick-prev"><img src="/assets/img/icon-carousel-left-green.png" srcset="/assets/img/icon-carousel-left-green.png 1x, /assets/img/icon-carousel-left-green@2x.png 2x" alt=""></span>',
});

$('.project-thumb').click(function(e) {
  e.preventDefault();

  // $('#project-viewer').modal({
  //   fadeDelay: 0.80,
  //   fadeDuration: 250
  // });

  $('#project-viewer').foundation('open');

  var index = $(this).data('index');
  // console.log(index);
  // slider.slick('slickGoTo', index);
  $('.project-viewer-images').slick('slickGoTo', index);

});


// Home page project slider
if ( $('.project-slider').length ) {
  $('.slick-dots').appendTo('.project-slide');
  
  $('.project-slider').slick({
    adaptiveHeight: true,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    dots: true,
    fade: true,
    infinite: true,
    nextArrow: '<span class="slick-next"><img src="/assets/img/icon-carousel-right.png" srcset="/assets/img/icon-carousel-right.png 1x, /assets/img/icon-carousel-right@2x.png 2x" alt=""></span>',
    prevArrow: '<span class="slick-prev"><img src="/assets/img/icon-carousel-left.png" srcset="/assets/img/icon-carousel-left.png 1x, /assets/img/icon-carousel-left@2x.png 2x" alt=""></span>',
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 1200
  });
}


// Sustainability slider on about page
if ( $('.sustainability-slider').length ) {
  $('.sustainability-slider').slick({
    adaptiveHeight: true,
    infinite: true,
    nextArrow: '<span class="slick-next"><img src="/assets/img/icon-carousel-right.png" srcset="/assets/img/icon-carousel-right.png 1x, /assets/img/icon-carousel-right@2x.png 2x" alt=""></span>',
    prevArrow: '<span class="slick-prev"><img src="/assets/img/icon-carousel-left.png" srcset="/assets/img/icon-carousel-left.png 1x, /assets/img/icon-carousel-left@2x.png 2x" alt=""></span>',
    slidesToScroll: 3,
    slidesToShow: 3
  });
}

// Community Outreach slider on about page
if ( $('.community-slider').length ) {
  $('.community-slider').slick({
    adaptiveHeight: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    mobileFirst: true,
    nextArrow: '<span class="slick-next"><img src="/assets/img/icon-carousel-right.png" srcset="/assets/img/icon-carousel-right.png 1x, /assets/img/icon-carousel-right@2x.png 2x" alt=""></span>',
    prevArrow: '<span class="slick-prev"><img src="/assets/img/icon-carousel-left.png" srcset="/assets/img/icon-carousel-left.png 1x, /assets/img/icon-carousel-left@2x.png 2x" alt=""></span>',
    slidesToScroll: 1,
    slidesToShow: 1,
    swipeToSlide: true
  });
}


// Community outreach slider modal on about page
if ( $('#modal-outreach').length ) {

  $('#modal-outreach').on('open.zf.reveal', function() {
    $('.outreach-nav').slick('setPosition', 0);
  });

  $('.outreach-slider').slick({
    asNavFor: '.outreach-nav',
    arrows: false,
    dots: false,
    fade: true,
    infinite: true,
    initialSlide: 1,
    slidesToScroll: 1,
    slidesToShow: 1
  });

  $('.outreach-nav').slick({
    asNavFor: '.outreach-slider',
    // arrows: true,
    dots: false,
    focusOnSelect: true,
    infinite: true,
    initialSlide: 1,
    nextArrow: '<span class="slick-next"><img src="/assets/img/icon-carousel-down-green.png" srcset="/assets/img/icon-carousel-down-green.png 1x, /assets/img/icon-carousel-down-green@2x.png 2x" alt=""></span>',
    prevArrow: '<span class="slick-prev"><img src="/assets/img/icon-carousel-up-green.png" srcset="/assets/img/icon-carousel-up-green.png 1x, /assets/img/icon-carousel-up-green@2x.png 2x" alt=""></span>',
    slidesToScroll: 1,
    slidesToShow: 4,
    vertical: true,
    responsive: [
      {
        breakpoint: 1080,
        settings: {
          nextArrow: '<span class="slick-next"><img src="/assets/img/icon-carousel-right-green.png" srcset="/assets/img/icon-carousel-right-green.png 1x, /assets/img/icon-carousel-right-green@2x.png 2x" alt=""></span>',
          prevArrow: '<span class="slick-prev"><img src="/assets/img/icon-carousel-left-green.png" srcset="/assets/img/icon-carousel-left-green.png 1x, /assets/img/icon-carousel-left-green@2x.png 2x" alt=""></span>',
          slidesToScroll: 1,
          slidesToShow: 3,
          vertical: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
}


// Awards slider modal on about page
if ( $('#modal-awards').length ) {

  $('#modal-awards').on('open.zf.reveal', function() {
    $('.awards-nav').slick('setPosition', 0);
  });

  $('.awards-slider').slick({
    asNavFor: '.awards-nav',
    arrows: false,
    dots: false,
    fade: true,
    infinite: true,
    initialSlide: 1,
    slidesToScroll: 1,
    slidesToShow: 1
  });

  $('.awards-nav').slick({
    asNavFor: '.awards-slider',
    // arrows: true,
    dots: false,
    focusOnSelect: true,
    infinite: true,
    initialSlide: 1,
    nextArrow: '<span class="slick-next"><img src="/assets/img/icon-carousel-down-green.png" srcset="/assets/img/icon-carousel-down-green.png 1x, /assets/img/icon-carousel-down-green@2x.png 2x" alt=""></span>',
    prevArrow: '<span class="slick-prev"><img src="/assets/img/icon-carousel-up-green.png" srcset="/assets/img/icon-carousel-up-green.png 1x, /assets/img/icon-carousel-up-green@2x.png 2x" alt=""></span>',
    slidesToScroll: 1,
    slidesToShow: 4,
    vertical: true,
    responsive: [
      {
        breakpoint: 1080,
        settings: {
          nextArrow: '<span class="slick-next"><img src="/assets/img/icon-carousel-right-green.png" srcset="/assets/img/icon-carousel-right-green.png 1x, /assets/img/icon-carousel-right-green@2x.png 2x" alt=""></span>',
          prevArrow: '<span class="slick-prev"><img src="/assets/img/icon-carousel-left-green.png" srcset="/assets/img/icon-carousel-left-green.png 1x, /assets/img/icon-carousel-left-green@2x.png 2x" alt=""></span>',
          slidesToScroll: 1,
          slidesToShow: 3,
          vertical: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });
}



// Touch devices
// ------------------------------------------------------------
$('.more-image-overlay').bind('touchstart', function() {
  $('.more-image-overlay').removeClass('hover-effect');
  $(this).addClass('hover-effect');
});



// Tabs prev/next
// ------------------------------------------------------------
if ( $('.tabs-content').length ) {
  $('.prev-tab').click(function() {
    $('.tabs li.is-active').prev().children('a').click();
  });

  $('.next-tab').click(function() {
    $('.tabs li.is-active').next().children('a').click();
  });

  $('#timeline-select').on('change', function () {
    var tab = $(this).val(); // get selected value
    // console.log(tab);
    
    $('.tabs-panel').removeClass('is-active');
    $('#' + tab).addClass('is-active');

  });
}